export default __webpack_public_path__ + "static/SRF 4700PW - Product Specifications & Technical Data-6b31ed71b4c30e3c3fd1c76d67216792.pdf";